var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 15.9699V68.5299C84.5025 69.2268 84.3084 69.9103 83.9399 70.5019C83.5714 71.0934 83.0435 71.569 82.4169 71.8739C81.7902 72.1789 81.0903 72.3009 80.3974 72.2259C79.7045 72.1509 79.0469 71.8819 78.5 71.4499L74.38 68.1299C72.2661 66.4221 69.9566 64.9719 67.5 63.8099C66.5223 63.3328 65.521 62.9055 64.5 62.5299V21.9699C65.521 21.5943 66.5223 21.1671 67.5 20.6899C69.9566 19.5279 72.2661 18.0777 74.38 16.3699L78.5 13.0499C79.0469 12.6179 79.7045 12.349 80.3974 12.274C81.0903 12.199 81.7902 12.3209 82.4169 12.6259C83.0435 12.9309 83.5714 13.4065 83.9399 13.998C84.3084 14.5895 84.5025 15.273 84.5 15.9699Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5 22.9297C58.3625 23.8103 55.1187 24.2545 51.86 24.2497H30.5C25.7261 24.2497 21.1477 26.1462 17.7721 29.5218C14.3964 32.8975 12.5 37.4758 12.5 42.2497C12.5 47.0236 14.3964 51.602 17.7721 54.9776C21.1477 58.3533 25.7261 60.2497 30.5 60.2497L40.288 79.8257C40.9522 81.155 41.9736 82.273 43.2375 83.0544C44.5014 83.8358 45.958 84.2497 47.444 84.2497H52.5L48.5 60.2497H51.86C55.1187 60.245 58.3625 60.6892 61.5 61.5697C62.5 61.8497 63.5 62.1697 64.5 62.5297V21.9697C63.5 22.3297 62.5 22.6497 61.5 22.9297Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.5603c64ca63a18408f5bfbaa00d3aa29.svg";
export { ForwardRef as ReactComponent };